import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, InputBaseComponent } from "components/input/baseInputDefinition";
import { OrginalValue } from "components/input/baseHTMLElementInput";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import $ from "jquery";
import { FocusManager } from "components/pages/focusManager";
import { Optgroup, Option } from "components/input/select/options";
import template from "./radioSelect.hbs";
import "./radioSelect.scss";

export class RadioSelectInput extends InputBaseComponent<RadioSelectInputDefinition> implements InputComponent {

    public readonly componentType: string = "radioSelectInput";

    private _initialValue: OrginalValue = new OrginalValue();

    constructor(schema: RadioSelectInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {
        const inputHTML: HTMLInputElement[] = Array.from(this.view.querySelectorAll("input"));

        inputHTML.forEach(input => {

            input.addEventListener("change", () => {
                const data = this.getValue();
                const isEqual = this.isEqualToInitialValue(data);
                if (!isEqual) {
                    this.initialValue.reassignvalue(data);
                    fireDataChangedEvent(this, this.view, this.getValue());
                }
            });

            if (this.definition.tabOnEnter === true) {
                input.addEventListener("keydown", (e) => {
                    if (e.key === "Enter") {
                        e.stopPropagation();
                        e.preventDefault();
                        FocusManager.focusNext();
                    }
                });
            }

        });
    }

    private isEqualToInitialValue(data: any): boolean {
        let isequal: boolean = true;
        const initialValue = this.initialValue.value;

        isequal = (this.getValue() == initialValue);

        return isequal;
    }

    public getValue(): string {
        const checked = this.view.querySelector("input:checked") as HTMLInputElement;
        const value = (checked == null ) ? null : checked.value;
        return value as string;
    }

    public value(v: string | number) {
        $(this.view).find("input[value='" + v + "']").prop("checked", true);
        this._initialValue.value = this.getValue();
    }

    public setReadOnly(ro: boolean) {
        this.view.querySelector("input").disabled = ro;
    }

    public setRequired(required: boolean) {
        if (required) {
            $(this.view).find("label").addClass("is-required");
        } else {
            $(this.view).find("label").removeClass("is-required");
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        if (valid) {
            $(this.view).find("label").removeClass("is-invalid");
        } else {
            $(this.view).find("label").addClass("is-invalid");
        }
    }

    public get initialValue() {
        return this._initialValue;
    }
}

export interface RadioSelectInputDefinition extends SimpleInputBaseDefinition {
    name?: string;
    options?: Array<Option | Optgroup>;
}
